import {IconButton} from "@mui/material";
import {GridFilterListIcon} from "@mui/x-data-grid";
import {ListHeaderFilteredProps} from "../../types/props";

const ListHeaderFiltered = ({apiRef, name, field}: ListHeaderFilteredProps) => {
  return (
    <div className="d-flex align-items-center gap-2">
      <span>{name}</span>
      <IconButton
        size="small"
        title="Filter"
        onClick={e => {
          e.stopPropagation();  // don't trigger sort when clicking the icon

          apiRef.current.showFilterPanel(field);
        }}
      >
        <GridFilterListIcon fontSize="small" color={
          // Filter can have items with empty value, so we need to check both field and value
          apiRef.current.state.filter.filterModel.items.some(f => f.field === field && !!f.value)
            ? 'success' // highlight if active
            : 'disabled'
        }/>
      </IconButton>
    </div>

  )
}

export default ListHeaderFiltered